import { queryClient, useMutation, useQuery } from '../../../hooks';

import * as adminService from '../service';
import { AdminCacheKeys } from '../consts';

export const useUsers = () => {
  const getUsers = useQuery({
    queryFn: adminService.getUsers,
    queryKey: [AdminCacheKeys.GetUsers],
  });

  const changeUserStatus = useMutation({
    mutationFn: adminService.changeUserStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [AdminCacheKeys.GetUsers] });
    },
  });

  return {
    getUsers,
    changeUserStatus,
  };
};
